import { useEffect } from "react";
import Overlay from "components/ui/loading-spinners/Overlay/Overlay";
import usePerformRouting from "features/PerformRouting";
import { useGetFeatureFlagsQuery } from "services/common/featureFlagService";

export default function AuthRouting() {
  const { data: featureFlag } = useGetFeatureFlagsQuery();

  const { isSuccess, performRouting } = usePerformRouting();

  useEffect(() => {
    if (isSuccess) {
      performRouting();
    }
  }, [isSuccess]);

  return <Overlay />;
}
